/**
 * Completely different system from Tempo, no numbers but names.
 * It shouldn't matter as these are only available to create semantic tokens.
 * If you need to convert it to numbered scale contact Zen's designer.
 * Updating this will not be a breaking change as it's not exposed.
 */ export const cocoaBrownPalette = {
    liver: '#342318',
    seal: '#5A3624',
    kobicha: '#653A20',
    brown: '#9E3C0A',
    cocoaBrown: '#CB6623',
    desertSand: '#DBC3B5',
    weakSand: '#E6BCA0',
    paleDogewood: '#EBCAB6',
    linen: '#EDE1DA',
    washedLinen: '#F3E7DF'
};
export const intentPalette = {
    green: '#00A237',
    orange: '#E89B17',
    red: '#D9321C'
};
export const umberPalette = {
    dimmedBistre: '#32231F',
    bistre: '#372C29',
    vanDyke: '#42342F',
    pureUmber: '#59443A',
    coffee: '#6F5445',
    umber: '#906C55',
    beaver: '#AF9585',
    khaki: '#C4B0A4',
    timberwolf: '#D9CCC4'
};
export const raisinBlackPalette = {
    black: '#000000',
    raisinBlack: '#211C1E',
    darkUmber: '#272021',
    dullUmber: '#403837',
    davyGray: '#625D5E',
    silver: '#8C8889',
    dullSand: '#D9D3D0',
    softSand: '#E3DBD7'
};
export const whiteSmokePalette = {
    whiteSmoke: '#F8F5F4',
    white: '#FFFFFF'
};
/**
 * Creates a standard color palette from a trio of intent
 * which some designers might prefer providing over
 * complete palettes
 */ export const createPaletteFromSemanticIntent = (main, weak, strong)=>({
        50: weak !== null && weak !== void 0 ? weak : main,
        60: weak !== null && weak !== void 0 ? weak : main,
        70: weak !== null && weak !== void 0 ? weak : main,
        80: weak !== null && weak !== void 0 ? weak : main,
        90: weak !== null && weak !== void 0 ? weak : main,
        100: main,
        110: strong !== null && strong !== void 0 ? strong : main,
        120: strong !== null && strong !== void 0 ? strong : main,
        130: strong !== null && strong !== void 0 ? strong : main,
        140: strong !== null && strong !== void 0 ? strong : main,
        150: strong !== null && strong !== void 0 ? strong : main
    });
export const primaryPaletteNumbered = createPaletteFromSemanticIntent(cocoaBrownPalette.cocoaBrown, cocoaBrownPalette.weakSand, cocoaBrownPalette.brown);

//# sourceMappingURL=colors.js.map